(function () {

  /**
   * Replace only the numeric portion of a formatted price string
   * while preserving currency symbols and spacing (Markets-safe)
   */
  function replaceNumber(formatted, newNumber) {
    if (!formatted) return '';

    const match = formatted.match(/[\d,.]+/);
    if (!match) return formatted;

    const formattedNumber = newNumber.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return formatted.replace(match[0], formattedNumber);
  }

window.applyVisualPrice = function (container) {

    if (!container) return;

    const enabled = String(container.dataset.enabled).toLowerCase() === 'true';
    if (!enabled) return;

    const mode = container.dataset.mode || 'off';
    const value = parseFloat(container.dataset.value || 0);
    const showCompare = String(container.dataset.showCompare).toLowerCase() === 'true';

    const basePrice = Math.round(Number(container.dataset.basePrice));
    if (!basePrice || basePrice <= 0 || mode === 'off') return;

    const priceMain = container.querySelector('.price-main');
    const priceCompare = container.querySelector('.price-compare');
    const separator = container.querySelector('.price-separator');

    if (!priceMain || !priceCompare) return;

    // Read original formatted price rendered by Shopify (currency-safe)
 // Build formatted price from base price (ALWAYS correct)
const baseValue = basePrice / 100;

const originalFormatted = replaceNumber(
  priceMain.textContent.trim(),
  baseValue
);


    let newPrice = basePrice;
    let comparePrice = null;

    switch (mode) {
      case 'percent':
        newPrice = Math.round(basePrice * (1 - value / 100));
        comparePrice = basePrice;
        break;

      case 'amount':
        newPrice = Math.max(basePrice - Math.round(value * 100), 0);
        comparePrice = basePrice;
        break;

      case 'compare':
        comparePrice = basePrice;
        break;
    }

if (showCompare && comparePrice && newPrice < comparePrice) {
  const discountedValue = newPrice / 100;

  // LEFT = discounted price
  priceMain.textContent = replaceNumber(originalFormatted, discountedValue);

  // RIGHT = original price
  priceCompare.textContent = originalFormatted;

  priceCompare.classList.remove('visually-hidden');
  if (separator) separator.classList.remove('visually-hidden');
} else {
  // Normal price fallback
  priceMain.textContent = originalFormatted;
  priceCompare.classList.add('visually-hidden');
  if (separator) separator.classList.add('visually-hidden');
}

  }

  function runVisualPricing(root = document) {
    root.querySelectorAll('.visual-price').forEach(applyVisualPrice);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => runVisualPricing());

  // Theme editor / section reloads (Impulse compatible)
  document.addEventListener('shopify:section:load', (e) => {
    runVisualPricing(e.target);
  });

  // Variant changes
  document.addEventListener('change', (e) => {
    if (e.target.matches('select[name="id"]')) {
      setTimeout(runVisualPricing, 50);
    }
  });

  // Shopify Markets / country switch
  document.addEventListener('currency:change', () => {
    setTimeout(runVisualPricing, 50);
  });

})();
// === Re-run visual pricing for dynamically injected content (Impulse-safe) ===
(function observeVisualPricing() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If a visual-price node itself is added
        if (node.classList && node.classList.contains('visual-price')) {
          applyVisualPrice(node);
        }

        // If visual-price nodes exist inside added content
        const visualPrices = node.querySelectorAll
          ? node.querySelectorAll('.visual-price')
          : [];

        visualPrices.forEach(applyVisualPrice);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
